 import * as Highcharts from "highcharts";
 import g from "../../globals/variables";

const ProfessionSalaryCalc = target => {
  // * ProfessionalSalaryCalculator.cshtml
  // * SalarySurveyController.cs

  const form = target;
  const el = {
    button: form.querySelector('button[type="submit"]'),
    results: form.querySelector(".calculator__result-boxes.js-salary-result")
  };
  let submitted = false;

  const method = {
    init: () => {
      form.addEventListener("submit", e => {
        e.preventDefault();
        method.submitForm(true);
      });

      el.results.style.display = "none";
    },

    submitForm: async showResults => {
      const data = new FormData(form);
      const action = form.getAttribute("action");
      const formMethod = form.getAttribute("method");
      const callout = form.querySelector(".callout");

      if (callout) {
        callout.remove();
      }
      
      el.button.disabled = true;
      el.button.classList.add("button--loading");

      fetch(action, {
        method: formMethod,
        body: data,
      })
        .then(res => res.json())
        .then(response => {
          if (response.success) {
            if (showResults) submitted = true;
            method.renderResults(response.result);

            //VEV
            method.renderCharts(response.result, "total");

            el.button.classList.remove("button--loading");
            el.button.disabled = false;
          } else {
            method.renderError(response.message, "error");
            el.button.classList.remove("button--loading");
            el.button.disabled = false;
          }
        })
        .catch(ex => {
          method.renderError(`Server error: ${ex}`, "error");
        });
    },

    allowResults: () => {
      method.submitForm(true);
      if (submitted) {
        el.results.removeAttribute("style");
      }
    },

    renderResults: response => {
      if (submitted) {
        el.results.removeAttribute("style");
      }
      // Warn: "MidgildiGrunn" and "MidgildiHeild" seems to be the avg. salary, not the median salary.
      let kronaISLocale = Intl.NumberFormat("is-IS");
  //    const salaries = response.map(r => r.Grunnlaun);
      const Percentile25 = response[0].Grunn25;
      const Percentile75 = response[0].Grunn75;
      const Midgildi = response[0].MidgildiGrunn;
      const Medaltal = response[0].MidgildiHeild;

      //MidgildiGrunn nota� fyrir me�altali�
      //MidgildiHeild nota� fyrir mi�gildi�

    /*  const avgSalary = kronaISLocale.format(
        Math.round(salaries.reduce((a, b) => a + b) / salaries.length),
      );

      let medianSalary = "0";
      if (salaries.length % 2 == 0) {
        medianSalary = kronaISLocale.format(
          Math.round((salaries[salaries.length / 2 - 1] + salaries[salaries.length / 2]) / 2),
        );
      } else {
        medianSalary = kronaISLocale.format(salaries[Math.round(salaries.length / 2) - 1]);
      }

*/
      form.querySelector(".js-MP_WA-sector-responders").innerHTML = response[0].Fjoldi;
      form.querySelector(".js-MP_WA-average-hours").innerHTML = response[0].Medalvinnustundir;

      form.querySelector(".js-MP_WA-average-wages").innerHTML = kronaISLocale.format(Midgildi).replace(",", ".").replace(",", ".") + " kr."; // avgSalary.replace(",", ".").replace(",", ".") + " kr.";
      form.querySelector(".js-MP_WA-midian-wages").innerHTML = kronaISLocale.format(Medaltal).replace(",", ".").replace(",", ".") + " kr."; // medianSalary.replace(",", ".").replace(",", ".") + " kr.";

      form.querySelector(".js-MP_WA-lower-limits").innerHTML = kronaISLocale.format(Percentile25).replace(",", ".").replace(",", ".") + " kr.";
      form.querySelector(".js-MP_WA-higher-limits").innerHTML = kronaISLocale.format(Percentile75).replace(",", ".").replace(",", ".") + " kr.";
            
    },

    renderCharts: (data, type) => {

      if (data.length > 0) {
        const chart1 = form.querySelector(".highchart--1");
        const chart2 = form.querySelector(".highchart--2");

       // const salaryType = type === "total" ? "Heildarlaun" : "Grunnlaun"; //window.dictionary.MP_WA_Total_Salaries : window.dictionary.MP_WA_Basic_Salaries;
        const date = new Date();
        let month = date.getMonth() - 3;
        let year = date.getFullYear();

        if (month === -3) {
          month = 9;
          year -= 1;
        } else if (month === -2) {
          month = 10;
          year -= 1;
        } else if (month === -1) {
          month = 11;
          year -= 1;
        }

        const monthNames = "jan�ar, febr�ar, mars, apr�l, ma�, j�n�, j�l�, �g�st, september, okt�ber, n�vember, desember".split(", ");  
        const monthName = monthNames && monthNames[month];

        const chartHeading =  "Laun � " +monthName + " " + year; 
        const chartSubheading = "Samanbur�ur vi� a�ra � s�mu starfsst�tt";

        Highcharts.setOptions({
          lang: {
            thousandsSep: ".",
          },
        });

        method.renderBarChart(
          data[0].TinLaun,
          data[0].MidgildiGrunn,
          data[0].MidgildiHeild,
          chartHeading,
          chartSubheading,
          chart1,
        );

        const data1 = [];
        const data2 = [];
        const data3 = [];

        data.forEach((r) => {
          data1.push([r.Heildarlaun, parseFloat(r.TinLaun)]);
          data2.push([r.Heildarlaun, parseFloat(r.MidgildiGrunn)]);
          data3.push([r.Heildarlaun, parseFloat(r.Grunnlaun)]);
        });

        method.renderLineChart(
          data1,
          data2,
          data3,
          chartHeading,
          chartSubheading,
          chart2,
        );
      }
    },

    renderError: (message, type) => {
      el.results.style.display = "none";

      form.insertAdjacentHTML(
        "beforeend",
        `<div class="callout callout--${type}">${message}</div>`,
      );
    },

    renderBarChart: (series1, series2, series3, heading, subheading, container) => {
      Highcharts.chart(container, {
        chart: {
          type: "column",
        },
        title: {
          style: {
            fontSize: "18px",
            fontWeight: 600,
            color: g.color.blueDark,
          },
          text: heading, // tegundLauna + "laun � " + monthNames[manudur] + " " + ar
        },
        subtitle: {
          text: subheading,
        },
        yAxis: [
          {
            // Primary yAxis
            labels: {
              format: "{value: ,.0f} kr.",
            },
            title: {
              text: "Laun � kr", //window.dictionary.CSS_Salary_in_isk, // "Laun � kr.",
            },
          },
        ],
        xAxis: {
          categories: [""],
        },
        plotOptions: {
          series: {
            states: {
              inactive: {
                opacity: 1,
              },
            },
          },
        },
        series: [
         /* {
            name: "��n laun", //window.dictionary.MP_WA_Your_Salary, // "��n laun",
            data: [series1],
            color: g.color.blueDark,
          },*/
          {
            name: "Me�allaun", //window.dictionary.CSS_Average, // "Me�allaun",
            data: [series2],
            color: g.color.blueLight,
          },
          {
            name: "Mi�gildi", //window.dictionary.CSS_Median, // "Mi�gildi",
            data: [series3],
            color: g.color.gray,
          },
        ],
      });
    },

    renderLineChart: (series1, series2, series3, heading, subheading, container) => {
      Highcharts.chart(container, {
        chart: {
          plotBorderWidth: 1, 
          plotShadow: false,
        },
        title: {
          text: heading, // "Laun � "  + monthNames[manudur] + " " + ar,
          style: {
            fontSize: "18px",
            fontWeight: 600,
            color: g.color.blueDark,
          },
        },
        subtitle: {
          text: subheading,
        },
        xAxis: {
          labels: {
            enabled: false,
          },
        },
        scrollbar: {
          enabled: false,
        },
        yAxis: [
          {
            // Primary yAxis
            labels: {
              format: "{value: ,.0f} kr.",
            },
            title: {
              text: "Laun � kr. ", //window.dictionary.CSS_Salary_in_isk, // "Laun � kr. ",
            },
          },
          {
            // Secondary yAxis
            gridLineWidth: 0,
            title: {
              text: "",
            },
            labels: {
              format: "{value} kr.",
            },
            opposite: true,
          },
        ],
        plotOptions: {
          series: {
            color: g.color.blueDark,
            marker: {
              enabled: false,
            },
          },
        },
        tooltip: {
          shared: true,
          crosshairs: true,
        },
        series: [
         /* {
            type: "line",
            name: "��n laun", //window.dictionary.MP_WA_Your_Salary, // "��n laun",
            data: series1,
            color: g.color.blueDark,
            tooltip: {
              valueSuffix: " kr.",
              headerFormat: "",
              pointFormat: `<b>{point.y}</b> ${ "eru ��n laun" }<br />`, // "<b>{point.y}</b> eru ��n laun <br/>",
            },
          }, */
          {
            type: "line",
            name: "Me�allaun � st�tt", //window.dictionary.CSS_Average_per_class, // "Me�allaun � st�tt",
            data: series2,
            color: g.color.blueLight,
            tooltip: {
              valueSuffix: " kr.",
              headerFormat: "",
              pointFormat: `<b>{point.y}</b> - me�allaun � v�ldum flokki<br />`, // "<b>{point.y}</b> me�allaun � v�ldum flokki <br/>",
            },
          },
          {
            type: "line",
            name: "Launadreifing", //window.dictionary.CSS_Wage_distribution, // "Launadreifing",
            data: series3,
            color: g.color.gray,
            tooltip: {
              valueSuffix: " kr.",
              headerFormat: "",
              pointFormat: `<b>{point.y}</b> - {point.x}% % eru me� j�fn e�a l�gri laun`, // "<b> {point.y}</b> ��sund ({point.x} % eru me� j�fn e�a l�gri laun)",
            },
          },
        ],
      });
    },

  };
  method.init();
};

export default ProfessionSalaryCalc;
